import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Page } from '../../../shared/model/page';
import { ActivatedRoute, Router } from '@angular/router';
import { BrokerMessagesService } from '../service/broker-messages.service';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss']
})
export class MessagesComponent implements OnInit {

  public contractMessageForm: FormGroup;
  public sortMessageForm: FormGroup;
  public contractMessages: Page<any>;
  public contractMessagesPageOffset = 0;
  public contractMessagesPageSize = 10;
  public paginationContractMessages = [];
  public isFilterExpanded: boolean;

  public contractMessageSettings = {
    actions: {
      custom: [
        {
          name: 'details',
          title: '<p>Detalii</p>'
        },
      ],
      add: false,
      edit: false,
      delete: false,
      position: 'right',
      columnTitle: 'Opțiuni',
    },
    hideSubHeader: true,
    sort: false,
    columns: {
      authorId: {
        title: 'Autor UUID'
      },
      messageId: {
        title: 'Mesaj ID'
      },
      correlationId: {
        title: 'Correlation ID'
      },
      timestamp: {
        title: 'Timestamp',
        valuePrepareFunction: (value: any) => value ? new Date(value).toLocaleString('ro-RO') : ''
      },
      type: {
        title: 'Tip'
      },
      number: {
        title: 'Numar contract'
      },
      supplierUuid: {
        title: 'Furnizor UUID'
      },
      placeCode: {
        title: 'POD/CLC'
      },
      operatorUuid: {
        title: 'Operator UUID'
      },
      clientCodeP: {
        title: 'CNP'
      },
      clientCodeC: {
        title: 'CUI'
      },
    }
  };

  constructor(
    private brokerMessagesService: BrokerMessagesService,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.initContractMessageForm();
    this.initSortMessageForm();
    this.searchContractMessages();
  }

  initContractMessageForm(): void {
    this.contractMessageForm = this.formBuilder.group({
      authorId: [''],
      messageId: [''],
      correlationId: [''],
      type: [''],
      number: [''],
      supplierUUID: [''],
      placeCode: [''],
      operatorUUID: [''],
      clientCodeP: [''],
      clientCodeC: [''],
      isInit: [''],
      isFromPosf: [''],
      isSuccess: ['']
    });
  }

  initSortMessageForm(): void {
    this.sortMessageForm = this.formBuilder.group({
      sortBy: [''],
      sortDirection: ['']
    });
  }

  onChangeSortCriteria(): void {
    if (this.sortMessageForm.controls.sortDirection.value === "") {
      this.sortMessageForm.controls.sortDirection.setValue("ASC");
    }
  }

  showMoreFilters(): void {
    this.isFilterExpanded = !this.isFilterExpanded;
  }

  searchContractMessages(): void {
    console.log('searchContractMessages', this.contractMessageForm.getRawValue());
    let sortBy = this.sortMessageForm.controls.sortBy.value;
    let sortDirection = this.sortMessageForm.controls.sortDirection.value;
    this.brokerMessagesService.getWebPosfMessages(
      {
        pageOffset: this.contractMessagesPageOffset,
        pageSize: this.contractMessagesPageSize,
        filter: this.contractMessageForm.getRawValue(),
        sort: sortBy,
        sortDirection: sortDirection
      }
    ).subscribe(result => {
      this.contractMessages = result;
      this.contractMessagesPageOffset = result.number;
      this.paginationContractMessages = [{ pageNumber: result.number, className: 'page-item active' }];
    });
  }

  onCustomActionContractMessage(event: any): void {
    console.log(event);
    switch (event.action) {
      case 'details':
        this.router.navigate(['..', 'mesaje-detalii'], {
          relativeTo: this.route, queryParams: {
            messageId: String(event.data.id),
            isInit: event.data.isInit,
            isFromPosf: event.data.isFromPosf,
            isSuccess: event.data.isSuccess,
            result: event.data.resultMessage
          }
        });
        break;
    }
  }

  changeContractMessagesPage(page: any): void {
    this.contractMessagesPageOffset = page.pageNumber;
    this.searchContractMessages();
  }

  previousContractMessagesPage(): void {
    this.contractMessagesPageOffset = this.contractMessagesPageOffset === 0 ? 0 : this.contractMessagesPageOffset - 1;
    this.searchContractMessages();
  }

  nextContractMessagesPage(): void {
    this.contractMessagesPageOffset = (this.contractMessagesPageOffset === this.contractMessages.totalPages - 1)
      ? this.contractMessagesPageOffset : this.contractMessagesPageOffset + 1;
    this.searchContractMessages();
  }

}
